export default __webpack_public_path__ + "static/media/academind.1fb5ec3e.webp";